module.exports = __webpack_public_path__ + "static/assets/92879f9b209387ab1f33e7aebc7cb60d.jpg";